import { create } from 'zustand'

interface AnnouncementStoreType {
  HeaderCategories:
    | {
        announcement: number
        update: number
        research: number
      }
    | any
  setHeaderCategories: (data: string) => void
}

export const useAnnouncementStore = create<AnnouncementStoreType>((set, get) => ({
  HeaderCategories: {
    announcement: 0,
    update: 0,
    research: 0
  },

  setHeaderCategories: (data: any) => {
    set({ HeaderCategories: data })
  }
}))
